<script>
export default {
  name: 'ChartThemeMixin',
  computed: {
    isDarkTheme() {
      return this.$store.getters.isDarkTheme
    },
    chartTheme() {
      if (this.isDarkTheme) {
        return {
          backgroundColor: '#1e2d3d',
          textColor: '#e8f1f8',
          gridLineColor: '#2a3f52',
          colors: ['#5cb3e6', '#3d8eb3', '#2a6b8f', '#1e5a7a', '#4aaae5', '#6bc5f0', '#8dd3f5', '#afe1fa']
        }
      } else {
        return {
          backgroundColor: '#ffffff',
          textColor: '#051B30',
          gridLineColor: '#E1E3EB',
          colors: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9']
        }
      }
    }
  }
}
</script>